import { WorkflowWriteBackMode } from 'libs/end-to-end/src/types/databases/workflows/workflow-write-back-mode';
import React, { useMemo, useCallback } from 'react';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';
import { S2Checkbox } from 'apps/sigma2-ui/src/components/ui/Checkbox';

export interface ConfigureWriteBackModeProps {
  mode: WorkflowWriteBackMode | null;
  updateMode: (details: WorkflowWriteBackMode | null) => void;
  skipWriteBackIfDuplicate?: boolean;
  updateSkipWriteBackIfDuplicate?: (skipWriteBackIfDuplicate: boolean) => void;
}

export const ConfigureWriteBackMode = ({
  mode,
  updateMode,
  skipWriteBackIfDuplicate = false,
  updateSkipWriteBackIfDuplicate,
}: ConfigureWriteBackModeProps) => {
  const selected: WorkflowWriteBackMode = useMemo(
    () => mode ?? 'no-writeback',
    [mode],
  );

  const list = useMemo(
    () => [
      { optionLabel: 'Normal', optionValue: 'normal' },
      { optionLabel: 'No Upstream', optionValue: 'no-upstream' },
      { optionLabel: 'No Writeback', optionValue: 'no-writeback' },
    ],
    [],
  );

  const setFn = useCallback(
    (selected: WorkflowWriteBackMode) => {
      updateMode(selected);
    },
    [updateMode],
  );

  const toggleSkipWriteBackIfDuplicate = useCallback(() => {
    updateSkipWriteBackIfDuplicate?.(!skipWriteBackIfDuplicate);
  }, [skipWriteBackIfDuplicate, updateSkipWriteBackIfDuplicate]);

  return (
    <div className="space-y-4 p-4 bg-white rounded shadow">
      <label className="block text-sm font-medium text-gray-700">
        Select write back mode (debug modes)
      </label>
      <SelectBoxWithSearch
        type="single"
        selected={selected}
        list={list}
        setSelected={setFn}
        label={'Write Back Mode'}
      />
      {updateSkipWriteBackIfDuplicate && (
        <S2Checkbox
          checked={skipWriteBackIfDuplicate}
          onChange={toggleSkipWriteBackIfDuplicate}
        >
          Also skip write back when this entity already has a prior successful
          write on this schedule (even if the payload changed)
        </S2Checkbox>
      )}
    </div>
  );
};
